"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradleWrapperScript = exports.installScriptFilename = exports.wrapperScriptFilename = void 0;
const path = __importStar(require("path"));
const fs_1 = __importDefault(require("fs"));
const IS_WINDOWS = process.platform === 'win32';
function wrapperScriptFilename() {
    return IS_WINDOWS ? './gradlew.bat' : './gradlew';
}
exports.wrapperScriptFilename = wrapperScriptFilename;
function installScriptFilename() {
    return IS_WINDOWS ? 'gradle.bat' : 'gradle';
}
exports.installScriptFilename = installScriptFilename;
function gradleWrapperScript(buildRootDirectory) {
    validateGradleWrapper(buildRootDirectory);
    return wrapperScriptFilename();
}
exports.gradleWrapperScript = gradleWrapperScript;
function validateGradleWrapper(buildRootDirectory) {
    const wrapperScript = path.resolve(buildRootDirectory, wrapperScriptFilename());
    verifyExists(wrapperScript, 'Gradle Wrapper script');
    verifyIsExecutableScript(wrapperScript);
    const wrapperProperties = path.resolve(buildRootDirectory, 'gradle/wrapper/gradle-wrapper.properties');
    verifyExists(wrapperProperties, 'Gradle wrapper properties file');
}
function verifyExists(file, description) {
    if (!fs_1.default.existsSync(file)) {
        throw new Error(`Cannot locate ${description} at '${file}'. Specify 'gradle-version' or 'gradle-executable' for projects without Gradle wrapper configured.`);
    }
}
function verifyIsExecutableScript(toExecute) {
    try {
        fs_1.default.accessSync(toExecute, fs_1.default.constants.X_OK);
    }
    catch (err) {
        throw new Error(`Gradle script '${toExecute}' is not executable.`);
    }
}
